export var SPECS;
(function (SPECS) {
    SPECS["URL_CUSTOMIZE"] = "specs.stores.EnableUrlCustomizeInProductPage";
    SPECS["USE_LIGHTBOXES"] = "specs.stores.UseLightboxes";
    SPECS["PRICE_RANGE_VIEWER"] = "specs.stores.PriceRangeViewer";
    SPECS["ORDERS_API_FORCE_NODE_ONLY_RESPONSE"] = "specs.stores.OrdersApiForceNodeOnlyResponse";
    //Cart mutations
    SPECS["USE_ADD_TO_CART_GRAPHQL_MUTATION"] = "specs.stores.UseAddToCartGraphQLMutation";
    SPECS["USE_SET_DESTINATION_GRAPHQL_MUTATION"] = "specs.stores.SetDestinationForEstimationMutation";
    SPECS["USE_SET_SHIPPING_OPTION_GRAPHQL_MUTATION"] = "specs.stores.SetShippingOptionGraphQLMutation";
    SPECS["USE_SET_COUPON_GRAPHQL_MUTATION"] = "specs.stores.UseSetCouponGraphQLMutation";
    SPECS["USE_REMOVE_COUPON_GRAPHQL_MUTATION"] = "specs.stores.UseRemoveCouponGraphQLMutation";
    SPECS["USE_CART_UPDATE_BUYER_NOTE_MUTATION"] = "specs.stores.UseCartUpdateBuyerNoteMutation";
    SPECS["USE_CART_REMOVE_ITEM_GRAPHQL_MUTATION"] = "specs.stores.UseCartRemoveItemGraphQLMutation";
    SPECS["GET_CART_PLATFORM"] = "specs.stores.GetCartPlatform";
    // Velo
    SPECS["MIGRATE_VELO_CART_ACTIONS_TO_CART_API"] = "specs.stores.MigrateVeloCartActionsToCartApi";
})(SPECS || (SPECS = {}));
export var BI_STOREFRONT_VIEW_MODE;
(function (BI_STOREFRONT_VIEW_MODE) {
    BI_STOREFRONT_VIEW_MODE["SITE"] = "site";
    BI_STOREFRONT_VIEW_MODE["PREVIEW"] = "preview";
    BI_STOREFRONT_VIEW_MODE["EDITOR"] = "editor";
})(BI_STOREFRONT_VIEW_MODE || (BI_STOREFRONT_VIEW_MODE = {}));
export var BI_PRODUCT_OPTION_TYPE;
(function (BI_PRODUCT_OPTION_TYPE) {
    BI_PRODUCT_OPTION_TYPE["COLOR"] = "color";
    BI_PRODUCT_OPTION_TYPE["LIST"] = "list";
})(BI_PRODUCT_OPTION_TYPE || (BI_PRODUCT_OPTION_TYPE = {}));
export var BI_PRODUCT_OPTION_ACTION;
(function (BI_PRODUCT_OPTION_ACTION) {
    BI_PRODUCT_OPTION_ACTION["CHECKED"] = "checked";
    BI_PRODUCT_OPTION_ACTION["UNCHECKED"] = "unchecked";
})(BI_PRODUCT_OPTION_ACTION || (BI_PRODUCT_OPTION_ACTION = {}));
//# sourceMappingURL=constants.js.map